export class Upload {
	public id: string;
	public typeId: string;
	public title: string;
	public comments: string;
	public caseId: string;
	public userId: string;
	public username: string;
	public custodianId: string;
	public custodianName: string;
	public isOcrOnServer: boolean;
	public isUploadToAmazonS3: boolean;
	public docSource: string;
	public utcOffset: number;
	public uploadDate: string;
	public isCreateFolders: boolean;
	public lifeCycle: number;
	public validationReportRoute: string;
	public validationStatus: UploadBatchValidationStatus;
	public docCount: number;
}

export enum UploadBatchValidationStatus{
	NotRun = "NotRun",
	Validating = "Validating",
	Passed = "Passed",
	Failed = "Failed",
	Warnings = "Warnings",
	Info = "Info",
	Unsupported = "Unsupported",
	Error = "Error"
}
